module.exports = __webpack_public_path__ + "static/img/首页方案1.a792d11b.png";